import * as React from 'react'

import LoadingSpinner from './icons/loadingSpinner'

const LoadingCover = () => {
  return (
    <div>
      <style>{`
      .js .loadingContainer {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 3;
        background: rgba(255, 255, 255, 1);
        text-align: center;
        padding-top: 44px;
      }
    `}</style>
      <div className="loadingContainer">
        <LoadingSpinner />
      </div>
    </div>
  )
}

export default LoadingCover
